var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask create-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size create_size" }, [
        _c(
          "a",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isPopupClose,
                expression: "isPopupClose"
              }
            ],
            staticClass: "ui_close",
            attrs: { href: "javascript:", type: "button" },
            on: { click: _vm.closePopup }
          },
          [_c("span", { staticClass: "sr_only" }, [_vm._v("popup close")])]
        ),
        _vm._v(" "),
        _c("dl", { staticClass: "modal_content" }, [
          _c("dt", { staticClass: "ellipsis" }, [
            _c("i", [_vm._v(_vm._s(_vm.getTitle))])
          ]),
          _vm._v(" "),
          _c("dd", { staticClass: "scroll_fixed" }, [
            _c("div", { staticClass: "register_wrap" }, [
              _c("div", { staticClass: "step_wrap" }, [
                _c("ul", [
                  _c(
                    "li",
                    {
                      class:
                        _vm.processStep === 1
                          ? "active"
                          : _vm.processStep > 1
                          ? "check"
                          : ""
                    },
                    [
                      _c("em", [_vm._v("1")]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.$t("MESSAGE.KNOWLEDGE.INSERT.DESCRIPTION"))
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      class:
                        _vm.processStep === 2
                          ? "active"
                          : _vm.processStep > 2
                          ? "check"
                          : ""
                    },
                    [
                      _c("em", [_vm._v("2")]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.$t("MESSAGE.KNOWLEDGE.INSERT.MODELLIST"))
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      class:
                        _vm.processStep === 3
                          ? "active"
                          : _vm.processStep > 3
                          ? "check"
                          : ""
                    },
                    [
                      _c("em", [_vm._v("3")]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.$t("MESSAGE.KNOWLEDGE.INSERT.PARTSLIST"))
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      class:
                        _vm.processStep === 4
                          ? "active"
                          : _vm.processStep > 4
                          ? "check"
                          : ""
                    },
                    [
                      _c("em", [_vm._v("4")]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.$t("MESSAGE.KNOWLEDGE.INSERT.VERHISTORY"))
                        )
                      ])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "table",
                { staticClass: "create_table" },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("caption", [
                    _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")]),
                    _vm._v(
                      "\r\n                                " +
                        _vm._s(_vm.$t("FIELD.GLOBAL.MANDATORY")) +
                        "\r\n                            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [
                      _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.TYPE"))),
                      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
                    ]),
                    _vm._v(" "),
                    _c("td", { attrs: { colspan: "5" } }, [
                      _c("fieldset", { staticClass: "ui_fieldset set_2" }, [
                        _c("div", [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.BOARD_TYPE1,
                                  expression: "BOARD_TYPE1"
                                },
                                {
                                  name: "validation",
                                  rawName: "v-validation",
                                  value: { groupId: "description" },
                                  expression: "{ groupId: 'description' }"
                                }
                              ],
                              staticClass: "slt_white w100p",
                              attrs: {
                                id: "BOARD_TYPE1",
                                name: "BOARD_TYPE1",
                                errorMessage: "MESSAGE.GLOBAL.VERIFICATION",
                                disabled:
                                  _vm.isBoardAccess ||
                                  _vm.isProcess ||
                                  _vm.isServiceScript ||
                                  !_vm.getIsModify
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.BOARD_TYPE1 = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                  function($event) {
                                    return _vm.changeBoardType1($event)
                                  }
                                ]
                              }
                            },
                            [
                              _c(
                                "option",
                                { attrs: { value: "", selected: "" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "FIELD.KNOWLEDGE.SEARCH.SELECTTYPE"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.boardType1List, function(item) {
                                return _vm.boardType1List.length > 0
                                  ? _c(
                                      "option",
                                      {
                                        key: item.code,
                                        domProps: { value: item.code }
                                      },
                                      [_vm._v(_vm._s(item.codeName))]
                                    )
                                  : _vm._e()
                              })
                            ],
                            2
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.BOARD_TYPE2,
                                  expression: "BOARD_TYPE2"
                                },
                                {
                                  name: "validation",
                                  rawName: "v-validation",
                                  value: { groupId: "description" },
                                  expression: "{ groupId: 'description' }"
                                }
                              ],
                              staticClass: "slt_white w100p",
                              attrs: {
                                id: "BOARD_TYPE2",
                                name: "BOARD_TYPE2",
                                errorMessage: "MESSAGE.GLOBAL.VERIFICATION",
                                disabled:
                                  _vm.isBoardAccess ||
                                  _vm.isProcess ||
                                  _vm.isServiceScript ||
                                  !_vm.getIsModify
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.BOARD_TYPE2 = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                  function($event) {
                                    return _vm.changeBoardType2($event)
                                  }
                                ]
                              }
                            },
                            [
                              _c(
                                "option",
                                { attrs: { value: "", selected: "" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "FIELD.KNOWLEDGE.SEARCH.SELECTTYPE"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.boardType2List, function(item) {
                                return _vm.boardType2List.length > 0
                                  ? _c(
                                      "option",
                                      {
                                        key: item.code,
                                        attrs: {
                                          "data-menu-grp-dtl-cd":
                                            item.menuGrpDtlCd
                                        },
                                        domProps: { value: item.code }
                                      },
                                      [_vm._v(_vm._s(item.codeName))]
                                    )
                                  : _vm._e()
                              })
                            ],
                            2
                          )
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [
                      _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.CATEGORY"))),
                      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
                    ]),
                    _vm._v(" "),
                    _c("td", { attrs: { colspan: "5" } }, [
                      _c("fieldset", { staticClass: "ui_fieldset set_3" }, [
                        _c("div", [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.PRD_CATEGORY_CD1,
                                  expression: "PRD_CATEGORY_CD1"
                                },
                                {
                                  name: "validation",
                                  rawName: "v-validation",
                                  value: { groupId: "description" },
                                  expression: "{ groupId: 'description' }"
                                }
                              ],
                              staticClass: "slt_white w100p",
                              attrs: {
                                id: "PRD_CATEGORY_CD1",
                                errorMessage: "MESSAGE.GLOBAL.VERIFICATION",
                                disabled:
                                  _vm.isProcess ||
                                  _vm.isServiceScript ||
                                  !_vm.getIsModify
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.PRD_CATEGORY_CD1 = $event.target
                                      .multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                  function($event) {
                                    return _vm.changeCategory1($event)
                                  }
                                ]
                              }
                            },
                            [
                              _c(
                                "option",
                                { attrs: { value: "", selected: "" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.categoryComboList1, function(item) {
                                return _vm.categoryComboList1.length > 0
                                  ? _c(
                                      "option",
                                      {
                                        key: item.code,
                                        domProps: { value: item.code }
                                      },
                                      [_vm._v(_vm._s(item.codeName))]
                                    )
                                  : _vm._e()
                              })
                            ],
                            2
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.PRD_CATEGORY_CD2,
                                  expression: "PRD_CATEGORY_CD2"
                                }
                              ],
                              staticClass: "slt_white w100p",
                              attrs: {
                                id: "PRD_CATEGORY_CD2",
                                disabled:
                                  _vm.isProcess ||
                                  _vm.isServiceScript ||
                                  !_vm.getIsModify
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.PRD_CATEGORY_CD2 = $event.target
                                      .multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                  function($event) {
                                    return _vm.changeCategory2($event)
                                  }
                                ]
                              }
                            },
                            [
                              _c(
                                "option",
                                { attrs: { value: "", selected: "" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.categoryComboList2, function(item) {
                                return _vm.categoryComboList2.length > 0
                                  ? _c(
                                      "option",
                                      {
                                        key: item.code,
                                        domProps: { value: item.code }
                                      },
                                      [_vm._v(_vm._s(item.codeName))]
                                    )
                                  : _vm._e()
                              })
                            ],
                            2
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.PRD_CATEGORY_CD3,
                                  expression: "PRD_CATEGORY_CD3"
                                }
                              ],
                              staticClass: "slt_white w100p",
                              attrs: {
                                id: "PRD_CATEGORY_CD3",
                                disabled:
                                  _vm.isProcess ||
                                  _vm.isServiceScript ||
                                  !_vm.getIsModify
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.PRD_CATEGORY_CD3 = $event.target
                                      .multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                  function($event) {
                                    return _vm.changeCategory3($event)
                                  }
                                ]
                              }
                            },
                            [
                              _c(
                                "option",
                                { attrs: { value: "", selected: "" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.categoryComboList3, function(item) {
                                return _vm.categoryComboList3.length > 0
                                  ? _c(
                                      "option",
                                      {
                                        key: item.code,
                                        domProps: { value: item.code }
                                      },
                                      [_vm._v(_vm._s(item.codeName))]
                                    )
                                  : _vm._e()
                              })
                            ],
                            2
                          )
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [
                      _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.SUBJECT"))),
                      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
                    ]),
                    _vm._v(" "),
                    _c("td", { attrs: { colspan: "5" } }, [
                      _c("span", { staticClass: "clearable" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.KNOWLEDGE_TITLE,
                              expression: "KNOWLEDGE_TITLE",
                              modifiers: { trim: true }
                            },
                            {
                              name: "validation",
                              rawName: "v-validation",
                              value: { groupId: "description" },
                              expression: "{ groupId: 'description' }"
                            }
                          ],
                          staticClass: "text_input w100p",
                          attrs: {
                            id: "KNOWLEDGE_TITLE",
                            type: "text",
                            placeholder: "",
                            maxlength: "270",
                            errorMessage: "MESSAGE.KNOWLEDGE.REQUIRE.SUBJECT",
                            disabled: _vm.isProcess || !_vm.getIsModify
                          },
                          domProps: { value: _vm.KNOWLEDGE_TITLE },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.KNOWLEDGE_TITLE = $event.target.value.trim()
                            },
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("i", { staticClass: "clearable_clear" }, [
                          _vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.DELETE")))
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.isRepair
                    ? _c("tr", [
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.SYMPTOM"))),
                          _vm.rtAndSb
                            ? _c("em", { staticClass: "txt_mandatory" }, [
                                _vm._v("*")
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { attrs: { colspan: "5" } },
                          [
                            _vm.symptomList.length < 2
                              ? _c(
                                  "fieldset",
                                  { staticClass: "ui_fieldset set_2" },
                                  [
                                    _vm.rtAndSb
                                      ? _c("div", [
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.symptomList[0]
                                                      .SYMPTOM_TYPE,
                                                  expression:
                                                    "symptomList[0].SYMPTOM_TYPE"
                                                },
                                                {
                                                  name: "validation",
                                                  rawName: "v-validation",
                                                  value: {
                                                    groupId: "description"
                                                  },
                                                  expression:
                                                    "{ groupId: 'description' }"
                                                }
                                              ],
                                              staticClass: "slt_white w100p",
                                              attrs: {
                                                id: _vm.getSymptomId(
                                                  "SYMPTOM_TYPE",
                                                  0
                                                ),
                                                errorMessage:
                                                  "MESSAGE.GLOBAL.VERIFICATION",
                                                disabled:
                                                  _vm.isProcess ||
                                                  !_vm.getIsModify
                                              },
                                              on: {
                                                change: [
                                                  function($event) {
                                                    var $$selectedVal = Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function(o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function(o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                    _vm.$set(
                                                      _vm.symptomList[0],
                                                      "SYMPTOM_TYPE",
                                                      $event.target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    )
                                                  },
                                                  function($event) {
                                                    return _vm.changeSymptomType(
                                                      0,
                                                      $event
                                                    )
                                                  }
                                                ]
                                              }
                                            },
                                            [
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value: "",
                                                    selected: ""
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "FIELD.KNOWLEDGE.SEARCH.SELECTSYMPTOM"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.symptomList[0]
                                                  .SYMPTOM_TYPEList,
                                                function(item) {
                                                  return _vm.symptomList[0]
                                                    .SYMPTOM_TYPEList.length > 0
                                                    ? _c(
                                                        "option",
                                                        {
                                                          key: item.code,
                                                          domProps: {
                                                            value: item.code
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.codeName
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        ])
                                      : _c("div", [
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.symptomList[0]
                                                      .SYMPTOM_TYPE,
                                                  expression:
                                                    "symptomList[0].SYMPTOM_TYPE"
                                                }
                                              ],
                                              staticClass: "slt_white w100p",
                                              attrs: {
                                                id: _vm.getSymptomId(
                                                  "SYMPTOM_TYPE",
                                                  0
                                                ),
                                                disabled:
                                                  _vm.isProcess ||
                                                  !_vm.getIsModify
                                              },
                                              on: {
                                                change: [
                                                  function($event) {
                                                    var $$selectedVal = Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function(o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function(o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                    _vm.$set(
                                                      _vm.symptomList[0],
                                                      "SYMPTOM_TYPE",
                                                      $event.target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    )
                                                  },
                                                  function($event) {
                                                    return _vm.changeSymptomType(
                                                      0,
                                                      $event
                                                    )
                                                  }
                                                ]
                                              }
                                            },
                                            [
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value: "",
                                                    selected: ""
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "FIELD.KNOWLEDGE.SEARCH.SELECTSYMPTOM"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.symptomList[0]
                                                  .SYMPTOM_TYPEList,
                                                function(item) {
                                                  return _vm.symptomList[0]
                                                    .SYMPTOM_TYPEList.length > 0
                                                    ? _c(
                                                        "option",
                                                        {
                                                          key: item.code,
                                                          domProps: {
                                                            value: item.code
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.codeName
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.symptomList[0]
                                                  .SYMPTOM_TYPE1,
                                              expression:
                                                "symptomList[0].SYMPTOM_TYPE1"
                                            }
                                          ],
                                          staticClass: "slt_white",
                                          class: _vm.isRepair
                                            ? "w80p"
                                            : "w100p",
                                          attrs: {
                                            id: _vm.getSymptomId(
                                              "SYMPTOM_TYPE1",
                                              0
                                            ),
                                            disabled:
                                              _vm.isProcess || !_vm.getIsModify
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.$set(
                                                _vm.symptomList[0],
                                                "SYMPTOM_TYPE1",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: { value: "", selected: "" }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FIELD.KNOWLEDGE.SEARCH.SELECTSYMPTOM"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.symptomList[0]
                                              .SYMPTOM_TYPE1List,
                                            function(item) {
                                              return _vm.symptomList[0]
                                                .SYMPTOM_TYPE1List.length > 0
                                                ? _c(
                                                    "option",
                                                    {
                                                      key: item.code,
                                                      domProps: {
                                                        value: item.code
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.codeName)
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            }
                                          )
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _vm.isRepair && _vm.getIsModify
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "in-btn-item",
                                              class: _vm.isProcess
                                                ? "disabled"
                                                : ""
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "ico_btn_add",
                                                  attrs: {
                                                    href: "javascript:",
                                                    title: _vm.$t(
                                                      "BUTTON.GLOBAL.ADD"
                                                    )
                                                  },
                                                  on: {
                                                    click: _vm.btnAddSymptom
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "sr_only" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "BUTTON.GLOBAL.ADD"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ])
                                  ]
                                )
                              : _vm._l(_vm.symptomList, function(symptom, idx) {
                                  return _c(
                                    "fieldset",
                                    { staticClass: "ui_fieldset set_2" },
                                    [
                                      _vm.rtAndSb
                                        ? _c("div", [
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: symptom.SYMPTOM_TYPE,
                                                    expression:
                                                      "symptom.SYMPTOM_TYPE"
                                                  },
                                                  {
                                                    name: "validation",
                                                    rawName: "v-validation",
                                                    value: {
                                                      groupId: "description"
                                                    },
                                                    expression:
                                                      "{ groupId: 'description' }"
                                                  }
                                                ],
                                                staticClass: "slt_white w100p",
                                                attrs: {
                                                  id: _vm.getSymptomId(
                                                    "SYMPTOM_TYPE",
                                                    idx
                                                  ),
                                                  errorMessage:
                                                    "MESSAGE.GLOBAL.VERIFICATION",
                                                  disabled:
                                                    _vm.isProcess ||
                                                    !_vm.getIsModify
                                                },
                                                on: {
                                                  change: [
                                                    function($event) {
                                                      var $$selectedVal = Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function(o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function(o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                      _vm.$set(
                                                        symptom,
                                                        "SYMPTOM_TYPE",
                                                        $event.target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      )
                                                    },
                                                    function($event) {
                                                      return _vm.changeSymptomType(
                                                        idx,
                                                        $event
                                                      )
                                                    }
                                                  ]
                                                }
                                              },
                                              [
                                                _c(
                                                  "option",
                                                  {
                                                    attrs: {
                                                      value: "",
                                                      selected: ""
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "FIELD.KNOWLEDGE.SEARCH.SELECTSYMPTOM"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  symptom.SYMPTOM_TYPEList,
                                                  function(item) {
                                                    return symptom
                                                      .SYMPTOM_TYPEList.length >
                                                      0
                                                      ? _c(
                                                          "option",
                                                          {
                                                            key: item.code,
                                                            domProps: {
                                                              value: item.code
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.codeName
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          ])
                                        : _c("div", [
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: symptom.SYMPTOM_TYPE,
                                                    expression:
                                                      "symptom.SYMPTOM_TYPE"
                                                  }
                                                ],
                                                staticClass: "slt_white w100p",
                                                attrs: {
                                                  id: _vm.getSymptomId(
                                                    "SYMPTOM_TYPE",
                                                    idx
                                                  ),
                                                  disabled:
                                                    _vm.isProcess ||
                                                    !_vm.getIsModify
                                                },
                                                on: {
                                                  change: [
                                                    function($event) {
                                                      var $$selectedVal = Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function(o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function(o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                      _vm.$set(
                                                        symptom,
                                                        "SYMPTOM_TYPE",
                                                        $event.target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      )
                                                    },
                                                    function($event) {
                                                      return _vm.changeSymptomType(
                                                        idx,
                                                        $event
                                                      )
                                                    }
                                                  ]
                                                }
                                              },
                                              [
                                                _c(
                                                  "option",
                                                  {
                                                    attrs: {
                                                      value: "",
                                                      selected: ""
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "FIELD.KNOWLEDGE.SEARCH.SELECTSYMPTOM"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  symptom.SYMPTOM_TYPEList,
                                                  function(item) {
                                                    return symptom
                                                      .SYMPTOM_TYPEList.length >
                                                      0
                                                      ? _c(
                                                          "option",
                                                          {
                                                            key: item.code,
                                                            domProps: {
                                                              value: item.code
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.codeName
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          ]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: symptom.SYMPTOM_TYPE1,
                                                expression:
                                                  "symptom.SYMPTOM_TYPE1"
                                              }
                                            ],
                                            staticClass: "slt_white",
                                            class: _vm.isRepair
                                              ? "w80p"
                                              : "w100p",
                                            attrs: {
                                              id: _vm.getSymptomId(
                                                "SYMPTOM_TYPE1",
                                                idx
                                              ),
                                              disabled:
                                                _vm.isProcess ||
                                                !_vm.getIsModify
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.$set(
                                                  symptom,
                                                  "SYMPTOM_TYPE1",
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "",
                                                  selected: ""
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "FIELD.KNOWLEDGE.SEARCH.SELECTSYMPTOM"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              symptom.SYMPTOM_TYPE1List,
                                              function(item) {
                                                return _vm.symptomList[idx]
                                                  .SYMPTOM_TYPE1List.length > 0
                                                  ? _c(
                                                      "option",
                                                      {
                                                        key: item.code,
                                                        domProps: {
                                                          value: item.code
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.codeName)
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              }
                                            )
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _vm.getIsModify
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "in-btn-item",
                                                class: _vm.isProcess
                                                  ? "disabled"
                                                  : ""
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "ico_btn_add",
                                                    attrs: {
                                                      href: "javascript:",
                                                      title: _vm.$t(
                                                        "BUTTON.GLOBAL.ADD"
                                                      )
                                                    },
                                                    on: {
                                                      click: _vm.btnAddSymptom
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "sr_only"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "BUTTON.GLOBAL.ADD"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                idx > 0
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "ico_btn_remove",
                                                        attrs: {
                                                          href: "javascript:",
                                                          title: _vm.$t(
                                                            "BUTTON.GLOBAL.REMOVE"
                                                          )
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.btnRemoveSymptom(
                                                              idx
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "sr_only"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "BUTTON.GLOBAL.REMOVE"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    ]
                                  )
                                })
                          ],
                          2
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [
                      _vm._v(
                        _vm._s(_vm.$t("FIELD.GLOBAL.IMPORTANT")) +
                          "\r\n                                    "
                      ),
                      _c("em", { staticClass: "ico_info" }, [
                        _c("i", { staticClass: "tooltip" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("MESSAGE.KNOWLEDGE.IMPORTANT.TOOLTIP")
                            )
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "label",
                        {
                          staticClass: "checkbox-wrap",
                          class:
                            _vm.isProcess || !_vm.getIsModify ? "disabled" : ""
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.importantYn,
                                expression: "importantYn"
                              }
                            ],
                            attrs: {
                              type: "checkbox",
                              name: "importantYn",
                              disabled: _vm.isProcess || !_vm.getIsModify
                            },
                            domProps: {
                              checked: Array.isArray(_vm.importantYn)
                                ? _vm._i(_vm.importantYn, null) > -1
                                : _vm.importantYn
                            },
                            on: {
                              change: [
                                function($event) {
                                  var $$a = _vm.importantYn,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.importantYn = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.importantYn = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.importantYn = $$c
                                  }
                                },
                                function($event) {
                                  return _vm.setCheckImpRead($event)
                                }
                              ]
                            }
                          }),
                          _c("i", { staticClass: "check-icon" })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(
                        _vm._s(_vm.$t("FIELD.GLOBAL.MUSTREAD")) +
                          "\r\n                                    "
                      ),
                      _c("em", { staticClass: "ico_info" }, [
                        _c("i", { staticClass: "tooltip" }, [
                          _vm._v(
                            _vm._s(_vm.$t("MESSAGE.KNOWLEDGE.MUSTREAD.TOOLTIP"))
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "label",
                        {
                          staticClass: "checkbox-wrap",
                          class:
                            _vm.isProcess || !_vm.getIsModify ? "disabled" : ""
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.mustreadYn,
                                expression: "mustreadYn"
                              }
                            ],
                            attrs: {
                              type: "checkbox",
                              name: "mustreadYn",
                              disabled: _vm.isProcess || !_vm.getIsModify
                            },
                            domProps: {
                              checked: Array.isArray(_vm.mustreadYn)
                                ? _vm._i(_vm.mustreadYn, null) > -1
                                : _vm.mustreadYn
                            },
                            on: {
                              change: [
                                function($event) {
                                  var $$a = _vm.mustreadYn,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.mustreadYn = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.mustreadYn = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.mustreadYn = $$c
                                  }
                                },
                                function($event) {
                                  return _vm.setCheckImpRead($event)
                                }
                              ]
                            }
                          }),
                          _c("i", { staticClass: "check-icon" })
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    !_vm.targetAllPass
                      ? _c("th", [
                          _vm._v(
                            "\r\n                                    " +
                              _vm._s(_vm.$t("FIELD.NOTICE.TARGET")) +
                              "\r\n                                "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.targetAllPass
                      ? _c("td", [
                          _c("fieldset", { staticClass: "ui_table" }, [
                            _c("span", { staticClass: "radio_item" }, [
                              !_vm.isRequestSharing
                                ? _c(
                                    "label",
                                    {
                                      staticClass: "radiobox-wrap",
                                      class:
                                        _vm.isProcess || !_vm.getIsModify
                                          ? "disabled"
                                          : ""
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.DIST_TARGET,
                                            expression: "DIST_TARGET"
                                          }
                                        ],
                                        attrs: {
                                          type: "radio",
                                          name: "rdo1",
                                          value: "S",
                                          disabled:
                                            _vm.isProcess || !_vm.getIsModify
                                        },
                                        domProps: {
                                          checked: _vm._q(_vm.DIST_TARGET, "S")
                                        },
                                        on: {
                                          change: function($event) {
                                            _vm.DIST_TARGET = "S"
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("i", { staticClass: "radio-icon" }),
                                      _vm._v(" "),
                                      _c("em", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FIELD.GLOBAL.SUBSIDIARY")
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.getDistributor
                                ? _c(
                                    "label",
                                    {
                                      staticClass: "radiobox-wrap",
                                      class:
                                        _vm.isProcess || !_vm.getIsModify
                                          ? "disabled"
                                          : ""
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.DIST_TARGET,
                                            expression: "DIST_TARGET"
                                          }
                                        ],
                                        attrs: {
                                          type: "radio",
                                          name: "rdo1",
                                          value: "G",
                                          disabled:
                                            _vm.isProcess || !_vm.getIsModify
                                        },
                                        domProps: {
                                          checked: _vm._q(_vm.DIST_TARGET, "G")
                                        },
                                        on: {
                                          change: function($event) {
                                            _vm.DIST_TARGET = "G"
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("i", { staticClass: "radio-icon" }),
                                      _vm._v(" "),
                                      _c("em", [
                                        _vm._v(
                                          _vm._s(_vm.$t("FIELD.GLOBAL.GLOBAL"))
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _vm.getDistributor
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "global_item",
                                    class:
                                      _vm.isProcess || !_vm.getIsModify
                                        ? "disabled"
                                        : ""
                                  },
                                  [
                                    _vm.DIST_TARGET === "G" &&
                                    _vm.selectSubsidiary.length > 0
                                      ? _c("fragment", [
                                          _c(
                                            "em",
                                            {
                                              staticClass: "tooltip_box",
                                              attrs: {
                                                name: "selectSubsidiary"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\r\n                                                    (\r\n                                                        " +
                                                  _vm._s(
                                                    _vm.selectSubsidiary.length
                                                  ) +
                                                  "\r\n                                                        "
                                              ),
                                              _vm.selectSubsidiary.length > 1
                                                ? [_vm._v(" Subsidiaries")]
                                                : [_vm._v(" Subsidiary")],
                                              _vm._v(
                                                "\r\n                                                    )\r\n                                                    "
                                              ),
                                              _c(
                                                "i",
                                                { staticClass: "tooltip" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.selectSubsidiary.join(
                                                        ", "
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            2
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.DIST_TARGET === "G" &&
                                    _vm.processStep === 1 &&
                                    _vm.getIsModify
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "ico_write_global",
                                            attrs: {
                                              href: "javascript:",
                                              disabled: _vm.isProcess
                                            },
                                            on: { click: _vm.globalTargetPop }
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "sr_only" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "BUTTON.KNOWLEDGE.GLOBALEDIT"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(
                        "\r\n                                    " +
                          _vm._s(_vm.$t("FIELD.KNOWLEDGE.ALLOWSHARING")) +
                          "\r\n                                    "
                      ),
                      _c("em", { staticClass: "ico_info" }, [
                        _c("i", { staticClass: "tooltip" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("MESSAGE.KNOWLEDGE.ALLOWSHARING.TOOLTIP")
                            )
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "label",
                        {
                          staticClass: "checkbox-wrap",
                          class:
                            _vm.isProcess || !_vm.getIsModify ? "disabled" : ""
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.isAllowSharing,
                                expression: "isAllowSharing"
                              }
                            ],
                            attrs: {
                              type: "checkbox",
                              name: "allowSharing",
                              disabled: _vm.isProcess || !_vm.getIsModify
                            },
                            domProps: {
                              checked: Array.isArray(_vm.isAllowSharing)
                                ? _vm._i(_vm.isAllowSharing, null) > -1
                                : _vm.isAllowSharing
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.isAllowSharing,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.isAllowSharing = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.isAllowSharing = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.isAllowSharing = $$c
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("i", { staticClass: "check-icon" })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.getMenuGrpDetailCd && _vm.getUserCorpCode
                      ? _c("th", [
                          _vm._v(
                            "\r\n                                     External Sharing\r\n                                "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.getMenuGrpDetailCd && _vm.getUserCorpCode
                      ? _c(
                          "td",
                          { attrs: { colspan: _vm.targetAllPass ? 3 : 1 } },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "checkbox-wrap",
                                class:
                                  _vm.isProcess || !_vm.getIsModify
                                    ? "disabled"
                                    : ""
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.isExternalSharing,
                                      expression: "isExternalSharing"
                                    }
                                  ],
                                  attrs: {
                                    type: "checkbox",
                                    name: "allowExternalSharing",
                                    disabled: _vm.isProcess || !_vm.getIsModify
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.isExternalSharing
                                    )
                                      ? _vm._i(_vm.isExternalSharing, null) > -1
                                      : _vm.isExternalSharing
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.isExternalSharing,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.isExternalSharing = $$a.concat(
                                              [$$v]
                                            ))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.isExternalSharing = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.isExternalSharing = $$c
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("i", { staticClass: "check-icon" })
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.isSCMSContents
                    ? _c("fragment", [
                        _c("tr", [
                          _c("th", [
                            _vm._v(
                              _vm._s(_vm.$t("FIELD.KNOWLEDGE.MANUFACTURE"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { attrs: { colspan: "5" } }, [
                            _c(
                              "fieldset",
                              { staticClass: "ui_fieldset pos-relative" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "date-wrap",
                                    class:
                                      _vm.isProcess || !_vm.getIsModify
                                        ? "disabled"
                                        : ""
                                  },
                                  [
                                    _c("label", [
                                      _c("input", {
                                        staticClass: "date_input w100p",
                                        attrs: {
                                          id: "fromDate",
                                          type: "text",
                                          placeholder: _vm.$t(
                                            "FIELD.KNOWLEDGE.SEARCH.FROMDATE"
                                          ),
                                          disabled: _vm.isProcess,
                                          readonly: "",
                                          maxlength: "20"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "in_btn",
                                          class:
                                            _vm.isProcess || !_vm.getIsModify
                                              ? "disabled"
                                              : "",
                                          attrs: {
                                            href: "javascript:",
                                            id: "icoFromDate"
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "sr_only" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FIELD.KNOWLEDGE.SEARCH.FROMDATE"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticStyle: { "margin-top": "-1px" },
                                      attrs: { id: "from-picker-container" }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c("em", { staticClass: "txt_space" }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "date-wrap",
                                    class:
                                      _vm.isProcess || !_vm.getIsModify
                                        ? "disabled"
                                        : ""
                                  },
                                  [
                                    _c("label", [
                                      _c("input", {
                                        staticClass: "date_input w100p",
                                        attrs: {
                                          id: "toDate",
                                          type: "text",
                                          placeholder: _vm.$t(
                                            "FIELD.KNOWLEDGE.SEARCH.TODATE"
                                          ),
                                          disabled: _vm.isProcess,
                                          readonly: "",
                                          maxlength: "20"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "in_btn",
                                          class:
                                            _vm.isProcess || !_vm.getIsModify
                                              ? "disabled"
                                              : "",
                                          attrs: {
                                            href: "javascript:",
                                            id: "icoToDate"
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "sr_only" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FIELD.KNOWLEDGE.SEARCH.TODATE"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticStyle: { "margin-top": "-1px" },
                                      attrs: { id: "to-picker-container" }
                                    })
                                  ]
                                )
                              ]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.showSerial
                          ? _c("tr", [
                              _c("th", [
                                _vm._v(
                                  _vm._s(_vm.$t("FIELD.QNA.SERIAL.NUMBER"))
                                ),
                                _vm.getGudieTypeVerifyUseYn &&
                                (_vm.getMenuCdSbYn || _vm.getMenuCdLocalSbYn)
                                  ? _c("em", { staticClass: "txt_mandatory" }, [
                                      _vm._v("*")
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { attrs: { colspan: "5", id: "snFields" } },
                                [
                                  _vm.serialList.length < 2
                                    ? _c(
                                        "fieldset",
                                        { staticClass: "ui_fieldset" },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass: "date-wrap",
                                              class:
                                                _vm.isProcess ||
                                                !_vm.getIsModify
                                                  ? "disabled"
                                                  : ""
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.serialList[0]
                                                        .SERIAL_S,
                                                    expression:
                                                      "serialList[0].SERIAL_S"
                                                  },
                                                  {
                                                    name: "regex",
                                                    rawName: "v-regex",
                                                    value: "/[^a-z0-9]/gi",
                                                    expression:
                                                      "'/[^a-z0-9]/gi'"
                                                  }
                                                ],
                                                staticClass: "text_input w100p",
                                                attrs: {
                                                  type: "text",
                                                  maxlength: "20",
                                                  disabled:
                                                    _vm.isProcess ||
                                                    !_vm.getIsModify
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.serialList[0].SERIAL_S
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.serialList[0],
                                                      "SERIAL_S",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("em", {
                                            staticClass: "txt_space"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              staticClass: "date-wrap",
                                              class:
                                                _vm.isProcess ||
                                                !_vm.getIsModify
                                                  ? "disabled"
                                                  : ""
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.serialList[0]
                                                        .SERIAL_E,
                                                    expression:
                                                      "serialList[0].SERIAL_E"
                                                  },
                                                  {
                                                    name: "regex",
                                                    rawName: "v-regex",
                                                    value: "/[^a-z0-9]/gi",
                                                    expression:
                                                      "'/[^a-z0-9]/gi'"
                                                  }
                                                ],
                                                staticClass: "text_input w100p",
                                                attrs: {
                                                  type: "text",
                                                  maxlength: "20",
                                                  disabled:
                                                    _vm.isProcess ||
                                                    !_vm.getIsModify
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.serialList[0].SERIAL_E
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.serialList[0],
                                                      "SERIAL_E",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.getIsModify
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass: "in-btn-item",
                                                  class: _vm.isProcess
                                                    ? "disabled"
                                                    : ""
                                                },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "ico_btn_add",
                                                      attrs: {
                                                        href: "javascript:",
                                                        title: _vm.$t(
                                                          "BUTTON.GLOBAL.ADD"
                                                        )
                                                      },
                                                      on: {
                                                        click: _vm.btnAddSerial
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "sr_only"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "BUTTON.GLOBAL.ADD"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._l(_vm.serialList, function(
                                        serial,
                                        idx
                                      ) {
                                        return _c(
                                          "fieldset",
                                          { staticClass: "ui_fieldset" },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass: "date-wrap",
                                                class:
                                                  _vm.isProcess ||
                                                  !_vm.getIsModify
                                                    ? "disabled"
                                                    : ""
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: serial.SERIAL_S,
                                                      expression:
                                                        "serial.SERIAL_S"
                                                    },
                                                    {
                                                      name: "regex",
                                                      rawName: "v-regex",
                                                      value: "/[^a-z0-9]/gi",
                                                      expression:
                                                        "'/[^a-z0-9]/gi'"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "text_input w100p",
                                                  attrs: {
                                                    type: "text",
                                                    maxlength: "20",
                                                    disabled:
                                                      _vm.isProcess ||
                                                      !_vm.getIsModify
                                                  },
                                                  domProps: {
                                                    value: serial.SERIAL_S
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        serial,
                                                        "SERIAL_S",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("em", {
                                              staticClass: "txt_space"
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "date-wrap",
                                                class:
                                                  _vm.isProcess ||
                                                  !_vm.getIsModify
                                                    ? "disabled"
                                                    : ""
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: serial.SERIAL_E,
                                                      expression:
                                                        "serial.SERIAL_E"
                                                    },
                                                    {
                                                      name: "regex",
                                                      rawName: "v-regex",
                                                      value: "/[^a-z0-9]/gi",
                                                      expression:
                                                        "'/[^a-z0-9]/gi'"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "text_input w100p",
                                                  attrs: {
                                                    type: "text",
                                                    maxlength: "20",
                                                    disabled:
                                                      _vm.isProcess ||
                                                      !_vm.getIsModify
                                                  },
                                                  domProps: {
                                                    value: serial.SERIAL_E
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        serial,
                                                        "SERIAL_E",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.getIsModify
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "in-btn-item",
                                                    class: _vm.isProcess
                                                      ? "disabled"
                                                      : ""
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "ico_btn_add",
                                                        attrs: {
                                                          href: "javascript:",
                                                          title: _vm.$t(
                                                            "BUTTON.GLOBAL.ADD"
                                                          )
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.btnAddSerial
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "sr_only"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "BUTTON.GLOBAL.ADD"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    idx > 0
                                                      ? _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "ico_btn_remove",
                                                            attrs: {
                                                              href:
                                                                "javascript:",
                                                              title: _vm.$t(
                                                                "BUTTON.GLOBAL.REMOVE"
                                                              )
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.btnRemoveSerial(
                                                                  idx
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "sr_only"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "BUTTON.GLOBAL.REMOVE"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      })
                                ],
                                2
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("FIELD.KNOWLEDGE.DEFECTTYPE")))
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.defectType,
                                    expression: "defectType"
                                  }
                                ],
                                staticClass: "slt_white w100p",
                                attrs: {
                                  disabled: _vm.isProcess || !_vm.getIsModify
                                },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.defectType = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              [
                                _c(
                                  "option",
                                  { attrs: { value: "", selected: "" } },
                                  [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ALL")))]
                                ),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "M" } }, [
                                  _vm._v("Common")
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "C" } }, [
                                  _vm._v("Call")
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "R" } }, [
                                  _vm._v("Repair")
                                ])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("FIELD.KNOWLEDGE.GUIDETYPE"))),
                            _vm.getGudieTypeVerifyUseYn && _vm.getMenuCdSbYn
                              ? _c("em", { staticClass: "txt_mandatory" }, [
                                  _vm._v("*")
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.guideType,
                                    expression: "guideType"
                                  }
                                ],
                                staticClass: "slt_white w100p",
                                attrs: {
                                  disabled: _vm.isProcess || !_vm.getIsModify
                                },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.guideType = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              [
                                _c(
                                  "option",
                                  { attrs: { value: "", selected: "" } },
                                  [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ALL")))]
                                ),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "P" } }, [
                                  _vm._v("Parts Used")
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "S" } }, [
                                  _vm._v("S/W & Firmware")
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "A" } }, [
                                  _vm._v("Alternative Parts")
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "O" } }, [
                                  _vm._v("On Site Check Guide")
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "R" } }, [
                                  _vm._v("Repair Information & Tips")
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "M" } }, [
                                  _vm._v("Manufacturing BOM Change")
                                ])
                              ]
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", { attrs: { colspan: "6" } }, [
                      _c("div", { staticClass: "tab_wrap" }, [
                        _c("ul", { staticClass: "tab_menu_03 tab_menus" }, [
                          _c(
                            "li",
                            { class: _vm.processStep === 1 ? "on" : "" },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "javascript:",
                                    title: _vm.$t("FIELD.GLOBAL.DESCRIPTION")
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("FIELD.GLOBAL.DESCRIPTION"))
                                  ),
                                  _c("em", { staticClass: "txt_mandatory" }, [
                                    _vm._v("*")
                                  ])
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            { class: _vm.processStep === 2 ? "on" : "" },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "javascript:",
                                    title: _vm.$t("FIELD.GLOBAL.MODEL.LIST")
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("FIELD.GLOBAL.MODEL.LIST"))
                                  ),
                                  _c("em", { staticClass: "ico_info" }, [
                                    _c("i", { staticClass: "tooltip" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "MESSAGE.KNOWLEDGE.MODELLIST.TOOLTIP"
                                          )
                                        )
                                      )
                                    ])
                                  ])
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            { class: _vm.processStep === 3 ? "on" : "" },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "javascript:",
                                    title: _vm.$t("FIELD.KNOWLEDGE.PARTSLISTS")
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("FIELD.KNOWLEDGE.PARTSLISTS"))
                                  ),
                                  _vm.showSerial
                                    ? _c(
                                        "em",
                                        { staticClass: "txt_mandatory" },
                                        [_vm._v("*")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("em", { staticClass: "ico_info" }, [
                                    _c("i", { staticClass: "tooltip" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "MESSAGE.KNOWLEDGE.PARTSLIST.TOOLTIP"
                                          )
                                        )
                                      )
                                    ])
                                  ])
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            { class: _vm.processStep === 4 ? "on" : "" },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "javascript:",
                                    title: _vm.$t("FIELD.KNOWLEDGE.VERHISTORY")
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("FIELD.KNOWLEDGE.VERHISTORY"))
                                  ),
                                  _c("em", { staticClass: "txt_mandatory" }, [
                                    _vm._v("*")
                                  ])
                                ]
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "tab_contents" }, [
                          _c(
                            "div",
                            {
                              staticClass: "tab_cont",
                              class: _vm.processStep === 1 ? "on" : ""
                            },
                            [
                              _vm.getIsModify || _vm.isServiceScript
                                ? _c("div", { staticClass: "in_btn" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "btn_templete",
                                        attrs: {
                                          href: "javascript:",
                                          title: _vm.$t(
                                            "FIELD.KNOWLEDGE.TEMPLATE"
                                          )
                                        },
                                        on: { click: _vm.templatePop }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FIELD.KNOWLEDGE.TEMPLATE")
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "btn_templete",
                                        attrs: {
                                          href: "javascript:",
                                          title: _vm.$t(
                                            "FIELD.GLOBAL.TRANSLATION"
                                          )
                                        },
                                        on: { click: _vm.translationPop }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FIELD.GLOBAL.TRANSLATION")
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "btn_templete",
                                        attrs: {
                                          href: "javascript:",
                                          title: _vm.$t(
                                            "FIELD.KNOWLEDGE.IMAGECLOUD"
                                          )
                                        },
                                        on: { click: _vm.imageCloudPop }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FIELD.KNOWLEDGE.IMAGECLOUD")
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.getIsModify || _vm.isServiceScript
                                ? _c(
                                    "fragment",
                                    [
                                      _vm.isImportNamo && !_vm.isLoading
                                        ? _c("cross-editor", {
                                            attrs: {
                                              editorId: _vm.getEditorId,
                                              editorData:
                                                _vm.KNOWLEDGE_DESC ||
                                                _vm.getServiceBulletinTemplate
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "btn_wrap text_right pt-10"
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "txt_link",
                                              attrs: {
                                                href: "javascript:",
                                                title: _vm.$t(
                                                  "BUTTON.KNOWLEDGE.DELETE.TEMPLATE"
                                                )
                                              },
                                              on: { click: _vm.resetTemplate }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "BUTTON.KNOWLEDGE.DELETE.TEMPLATE"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _c(
                                    "fragment",
                                    [
                                      _vm.isImportNamo && !_vm.isLoading
                                        ? _c("cross-editor-viewer", {
                                            attrs: {
                                              editorId: _vm.getViewerId,
                                              editorData:
                                                _vm.KNOWLEDGE_DESC ||
                                                _vm.getServiceBulletinTemplate
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "tab_cont",
                              class: _vm.processStep === 2 ? "on" : ""
                            },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "resize",
                                      rawName: "v-resize",
                                      value: _vm.setGridResizeColumn(
                                        _vm.processStep
                                      ),
                                      expression:
                                        "setGridResizeColumn(processStep)"
                                    }
                                  ],
                                  staticClass: "grid_wrap"
                                },
                                [
                                  _vm.getIsModify || _vm.isServiceScript
                                    ? _c("div", { staticClass: "grid_top" }, [
                                        _c(
                                          "fieldset",
                                          { staticClass: "ui_fieldset" },
                                          [
                                            _c(
                                              "label",
                                              { staticClass: "serach-wrap" },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.searchModel,
                                                      expression: "searchModel"
                                                    }
                                                  ],
                                                  staticClass: "text_input",
                                                  attrs: {
                                                    type: "text",
                                                    placeholder: _vm.$t(
                                                      "FIELD.PLACEHOLDER.KNOWLEDGE.SEARCH"
                                                    )
                                                  },
                                                  domProps: {
                                                    value: _vm.searchModel
                                                  },
                                                  on: {
                                                    keyup: function($event) {
                                                      if (
                                                        !$event.type.indexOf(
                                                          "key"
                                                        ) &&
                                                        _vm._k(
                                                          $event.keyCode,
                                                          "enter",
                                                          13,
                                                          $event.key,
                                                          "Enter"
                                                        )
                                                      ) {
                                                        return null
                                                      }
                                                      $event.stopPropagation()
                                                      return _vm.modelSearchPop(
                                                        $event
                                                      )
                                                    },
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.searchModel =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "in_btn_search",
                                                    attrs: {
                                                      href: "javascript:",
                                                      title: _vm.$t(
                                                        "FIELD.GLOBAL.SEARCH"
                                                      )
                                                    },
                                                    on: {
                                                      click: _vm.modelSearchPop
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "ico_input_serach"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "sr_only"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "FIELD.GLOBAL.SEARCH"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "btn_wrap" }, [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "btn_sm_white",
                                              attrs: {
                                                href: "javascript:",
                                                title: _vm.$t(
                                                  "BUTTON.GLOBAL.SAMPLE.DOWNLOAD"
                                                )
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.downloadWithAxios(
                                                    "model"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "BUTTON.GLOBAL.SAMPLE.DOWNLOAD"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "btn_filebox btn_sm_white"
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for: "model_file_id"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "BUTTON.GLOBAL.FILE.UPLOAD"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("input", {
                                                ref: "model_file_ref",
                                                attrs: {
                                                  type: "file",
                                                  id: "model_file_id",
                                                  accept:
                                                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.modelUpload(
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "btn_sm_white",
                                              class: _vm.isModelValidation
                                                ? ""
                                                : "disabled",
                                              attrs: {
                                                href: "javascript:",
                                                title: _vm.$t(
                                                  "BUTTON.KNOWLEDGE.MODEL.VALIDATION"
                                                )
                                              },
                                              on: { click: _vm.modelValidation }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "BUTTON.KNOWLEDGE.MODEL.VALIDATION"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "btn_sm_white",
                                              attrs: {
                                                href: "javascript:",
                                                title: _vm.$t(
                                                  "BUTTON.GLOBAL.DELETEALL"
                                                )
                                              },
                                              on: { click: _vm.modelAllDelete }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "BUTTON.GLOBAL.DELETEALL"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.processStep === 2
                                    ? _c("model-grid", {
                                        ref: _vm.getMdlGridId,
                                        attrs: {
                                          gridId: _vm.getMdlGridId,
                                          columns: _vm.modelColumns,
                                          data: _vm.modelList,
                                          options: _vm.options,
                                          pageOptions: _vm.pageOptions,
                                          isTotalCount: false,
                                          click: _vm.modelColumnClick
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "page_wrap top20" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "grid_total" },
                                        [
                                          _c("em", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("numberFormat")(
                                                  _vm.modelList.length
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("FIELD.GLOBAL.MODEL")
                                              )
                                          ),
                                          _vm.modelList.length > 1
                                            ? [_vm._v("s")]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.showFailCnt
                                            ? _c(
                                                "span",
                                                { staticClass: "fail" },
                                                [
                                                  _vm._v(
                                                    "\r\n                                                                (\r\n                                                                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "FIELD.KNOWLEDGE.MODEL.FAIL"
                                                        )
                                                      ) +
                                                      " : " +
                                                      _vm._s(
                                                        _vm._f("numberFormat")(
                                                          _vm.validFailCnt
                                                        )
                                                      ) +
                                                      "\r\n                                                                    "
                                                  ),
                                                  _c(
                                                    "em",
                                                    { staticClass: "ico_info" },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass: "tooltip"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "MESSAGE.KNOWLEDGE.MODEL.VALIDATION.TOOLTIP"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    "\r\n                                                                )\r\n                                                            "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "tab_cont",
                              class: _vm.processStep === 3 ? "on" : ""
                            },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "resize",
                                      rawName: "v-resize",
                                      value: _vm.setGridResizeColumn(
                                        _vm.processStep
                                      ),
                                      expression:
                                        "setGridResizeColumn(processStep)"
                                    }
                                  ],
                                  staticClass: "grid_wrap"
                                },
                                [
                                  _vm.getIsModify || _vm.isServiceScript
                                    ? _c("div", { staticClass: "grid_top" }, [
                                        _c("div", { staticClass: "btn_wrap" }, [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "btn_sm_white",
                                              attrs: {
                                                href: "javascript:",
                                                title: _vm.$t(
                                                  "BUTTON.GLOBAL.SAMPLE.DOWNLOAD"
                                                )
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.sampleExcelDownload()
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "BUTTON.GLOBAL.SAMPLE.DOWNLOAD"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "btn_filebox btn_sm_white"
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for: "parts_file_id"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "BUTTON.GLOBAL.FILE.UPLOAD"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("input", {
                                                ref: "parts_file_ref",
                                                attrs: {
                                                  type: "file",
                                                  id: "parts_file_id",
                                                  accept:
                                                    "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.partsUpload(
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "btn_sm_white",
                                              attrs: {
                                                href: "javascript:",
                                                title: _vm.$t(
                                                  "BUTTON.GLOBAL.DELETEALL"
                                                )
                                              },
                                              on: { click: _vm.partsAllDelete }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "BUTTON.GLOBAL.DELETEALL"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.processStep === 3
                                    ? _c("parts-grid", {
                                        ref: _vm.getPtsGridId,
                                        attrs: {
                                          gridId: _vm.getPtsGridId,
                                          columns: _vm.partsColumns,
                                          data: _vm.partsList,
                                          options: _vm.options,
                                          pageOptions: _vm.pageOptions,
                                          isTotalCount: false
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "tab_cont",
                              class: _vm.processStep === 4 ? "on" : ""
                            },
                            [
                              _c("table", { staticClass: "data_table" }, [
                                _vm._m(1),
                                _vm._v(" "),
                                _c("thead", [
                                  _c("tr", { staticClass: "text_center" }, [
                                    _c("th", [
                                      _vm._v(
                                        _vm._s(_vm.$t("FIELD.GLOBAL.VERSION"))
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { staticClass: "pc_only" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("FIELD.GLOBAL.DATE"))
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { staticClass: "pc_only" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("FIELD.GLOBAL.EDITOR"))
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [
                                      _vm._v(
                                        _vm._s(_vm.$t("FIELD.GLOBAL.DETAILS"))
                                      )
                                    ])
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "tbody",
                                  { staticClass: "text_center" },
                                  [
                                    _vm.versionList.length === 0 ||
                                    (_vm.versionList.length === 1 &&
                                      typeof _vm.versionList[0].MODF_REASON ===
                                        "undefined" &&
                                      (_vm.STATUS === "P" || _vm.STATUS === ""))
                                      ? _c("tr", [
                                          _c("td", [_vm._v("Ver.1")]),
                                          _vm._v(" "),
                                          _c("td", { staticClass: "pc_only" }, [
                                            _vm._v(_vm._s(_vm.getEditDate))
                                          ]),
                                          _vm._v(" "),
                                          _c("td", { staticClass: "pc_only" }, [
                                            _vm._v(_vm._s(_vm.getEditor))
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text_left" },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "clearable" },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model.trim",
                                                        value: _vm.versionDesc,
                                                        expression:
                                                          "versionDesc",
                                                        modifiers: {
                                                          trim: true
                                                        }
                                                      },
                                                      {
                                                        name: "validation",
                                                        rawName: "v-validation",
                                                        value: {
                                                          groupId: "description"
                                                        },
                                                        expression:
                                                          "{ groupId: 'description' }"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "text_input w100p",
                                                    attrs: {
                                                      id: "MODF_REASON",
                                                      type: "text",
                                                      placeholder: _vm.$t(
                                                        "FIELD.KNOWLEDGE.VERSION.PLACEHOLDER"
                                                      ),
                                                      title: _vm.$t(
                                                        "BUTTON.GLOBAL.DELETE"
                                                      ),
                                                      errorMessage:
                                                        "MESSAGE.GLOBAL.VERIFICATION"
                                                    },
                                                    domProps: {
                                                      value: _vm.versionDesc
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.versionDesc = $event.target.value.trim()
                                                      },
                                                      blur: function($event) {
                                                        return _vm.$forceUpdate()
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "clearable_clear"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "BUTTON.GLOBAL.DELETE"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      : _c(
                                          "fragment",
                                          [
                                            _vm.getIsModify ||
                                            _vm.isServiceScript
                                              ? _c("tr", [
                                                  _c("td", [
                                                    _vm._v(
                                                      "Ver." +
                                                        _vm._s(
                                                          _vm.versionList
                                                            .length + 1
                                                        )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    { staticClass: "pc_only" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(_vm.getEditDate)
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    { staticClass: "pc_only" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(_vm.getEditor)
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text_left"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "clearable"
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model.trim",
                                                                value:
                                                                  _vm.versionDesc,
                                                                expression:
                                                                  "versionDesc",
                                                                modifiers: {
                                                                  trim: true
                                                                }
                                                              },
                                                              {
                                                                name:
                                                                  "validation",
                                                                rawName:
                                                                  "v-validation",
                                                                value: {
                                                                  groupId:
                                                                    "description"
                                                                },
                                                                expression:
                                                                  "{ groupId: 'description' }"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "text_input w100p",
                                                            attrs: {
                                                              id: "MODF_REASON",
                                                              type: "text",
                                                              placeholder: _vm.$t(
                                                                "FIELD.KNOWLEDGE.VERSION.PLACEHOLDER"
                                                              ),
                                                              title: _vm.$t(
                                                                "BUTTON.GLOBAL.DELETE"
                                                              ),
                                                              errorMessage:
                                                                "MESSAGE.GLOBAL.VERIFICATION"
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.versionDesc
                                                            },
                                                            on: {
                                                              input: function(
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.versionDesc = $event.target.value.trim()
                                                              },
                                                              blur: function(
                                                                $event
                                                              ) {
                                                                return _vm.$forceUpdate()
                                                              }
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "i",
                                                            {
                                                              staticClass:
                                                                "clearable_clear"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "BUTTON.GLOBAL.DELETE"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm._l(_vm.versionList, function(
                                              version,
                                              idx
                                            ) {
                                              return _c("tr", [
                                                _c("td", [
                                                  _vm._v(
                                                    "Ver." +
                                                      _vm._s(version.VERSION_NO)
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { staticClass: "pc_only" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(version.MODF_DT)
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { staticClass: "pc_only" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(version.MODF_USER)
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { staticClass: "text_left" },
                                                  [
                                                    idx > 0
                                                      ? _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "over_line",
                                                            attrs: {
                                                              href:
                                                                "javascript:"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.seeDetailPop(
                                                                  version.KNOWLEDGE_ID,
                                                                  version.VERSION_NO
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\r\n                                                                        " +
                                                                _vm._s(
                                                                  version.MODF_REASON
                                                                ) +
                                                                "\r\n                                                                    "
                                                            )
                                                          ]
                                                        )
                                                      : [
                                                          _vm._v(
                                                            _vm._s(
                                                              version.MODF_REASON
                                                            )
                                                          )
                                                        ],
                                                    _vm._v(" "),
                                                    typeof version.APPROVAL_ID !==
                                                    "undefined"
                                                      ? _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "txt_link",
                                                            attrs: {
                                                              href:
                                                                "javascript:"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.seeApprovalHistoryPop(
                                                                  version.APPROVAL_ID
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\r\n                                                                        " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "FIELD.GLOBAL.ETC.001"
                                                                  )
                                                                ) +
                                                                "\r\n                                                                    "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  2
                                                )
                                              ])
                                            })
                                          ],
                                          2
                                        )
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _vm.isPrevious
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "btn_wrap text_right pt-10"
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "txt_link",
                                          attrs: {
                                            href: "javascript:",
                                            title: _vm.$t(
                                              "FIELD.KNOWLEDGE.SEE.PREVIOUS"
                                            )
                                          },
                                          on: { click: _vm.seePrevPop }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "FIELD.KNOWLEDGE.SEE.PREVIOUS"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", { staticClass: "noLine" }, [
                    _c("th", [
                      _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ATTACHMENT")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "no_padding", attrs: { colspan: "5" } },
                      [
                        !_vm.isLoading
                          ? _c("innorix-upload", {
                              attrs: {
                                id: _vm.getUploadId,
                                name: _vm.getUploadId,
                                uploadId: _vm.getUploadId,
                                onlyUpload: _vm.onlyUpload,
                                attachList: _vm.attachFileSeq,
                                buttonDisable: !_vm.getIsModify,
                                isSCMSDirect: _vm.isSCMSDirect
                              },
                              on: { files: _vm.setAttachFiles }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("dd", { staticClass: "scroll_btm" }, [
            _c("div", { staticClass: "btn_wrap_full topLine" }, [
              _vm.processStep > 1
                ? _c(
                    "a",
                    {
                      staticClass: "btn_white",
                      attrs: {
                        href: "javascript:",
                        title: _vm.$t("BUTTON.GLOBAL.PREVIOUS")
                      },
                      on: { click: _vm.btnPrevious }
                    },
                    [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.PREVIOUS")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isAdminMenu
                ? _c("div", { staticClass: "btn_right" }, [
                    _vm.isAdminMenu &&
                    _vm.adminButtonAuth &&
                    ((_vm.adminMenuType === "EPD" && _vm.STATUS === "E") ||
                      (_vm.adminMenuType === "TRS" && _vm.STATUS === "T"))
                      ? _c(
                          "a",
                          {
                            staticClass: "btn_white",
                            attrs: { href: "javascript:" },
                            on: { click: _vm.btnRecover }
                          },
                          [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.RECOVER")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isAdminMenu &&
                    _vm.adminButtonAuth &&
                    _vm.adminMenuType === "EPD" &&
                    _vm.STATUS === "E"
                      ? _c(
                          "a",
                          {
                            staticClass: "btn_white",
                            attrs: { href: "javascript:" },
                            on: { click: _vm.btnTrash }
                          },
                          [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.TRASH")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isAdminMenu &&
                    _vm.adminButtonAuth &&
                    _vm.adminMenuType === "EXP" &&
                    _vm.STATUS === "S"
                      ? _c(
                          "a",
                          {
                            staticClass: "btn_white",
                            attrs: { href: "javascript:" },
                            on: { click: _vm.btnExtendPeriod }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("BUTTON.GLOBAL.EXTEND.PERIOD"))
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isAdminMenu &&
                    _vm.adminButtonAuth &&
                    _vm.adminMenuType === "TRS" &&
                    _vm.STATUS === "T"
                      ? _c(
                          "a",
                          {
                            staticClass: "btn_white",
                            attrs: { href: "javascript:" },
                            on: { click: _vm.btnRemove }
                          },
                          [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.REMOVE")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.processStep < 4
                      ? _c(
                          "a",
                          {
                            staticClass: "btn_blue",
                            attrs: {
                              href: "javascript:",
                              title: _vm.$t("BUTTON.GLOBAL.NEXT")
                            },
                            on: { click: _vm.btnNext }
                          },
                          [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.NEXT")))]
                        )
                      : _vm._e()
                  ])
                : _vm.isServiceScript
                ? _c("div", { staticClass: "btn_right" }, [
                    _vm.processStep > 3
                      ? _c(
                          "a",
                          {
                            staticClass: "btn_blue",
                            attrs: { href: "javascript:" },
                            on: { click: _vm.btnAddContentsSave }
                          },
                          [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.SAVE")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.processStep < 4
                      ? _c(
                          "a",
                          {
                            staticClass: "btn_blue",
                            attrs: {
                              href: "javascript:",
                              title: _vm.$t("BUTTON.GLOBAL.NEXT")
                            },
                            on: { click: _vm.btnNext }
                          },
                          [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.NEXT")))]
                        )
                      : _vm._e()
                  ])
                : _vm.isSCMSDirect
                ? _c("div", { staticClass: "btn_right" }, [
                    (_vm.STATUS === "S" || _vm.STATUS === "C") &&
                    !_vm.getIsModify
                      ? _c(
                          "a",
                          {
                            staticClass: "btn_white",
                            attrs: { href: "javascript:" },
                            on: { click: _vm.btnModify }
                          },
                          [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.EDIT")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.processStep > 3 && _vm.getIsModify
                      ? _c(
                          "a",
                          {
                            staticClass: "btn_blue",
                            attrs: { href: "javascript:" },
                            on: { click: _vm.btnRegister }
                          },
                          [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.REGISTER")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.processStep < 4
                      ? _c(
                          "a",
                          {
                            staticClass: "btn_blue",
                            attrs: {
                              href: "javascript:",
                              title: _vm.$t("BUTTON.GLOBAL.NEXT")
                            },
                            on: { click: _vm.btnNext }
                          },
                          [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.NEXT")))]
                        )
                      : _vm._e()
                  ])
                : _vm.isOnlyView
                ? _c("div", { staticClass: "btn_right" }, [
                    _vm.processStep < 4
                      ? _c(
                          "a",
                          {
                            staticClass: "btn_blue",
                            attrs: {
                              href: "javascript:",
                              title: _vm.$t("BUTTON.GLOBAL.NEXT")
                            },
                            on: { click: _vm.btnNext }
                          },
                          [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.NEXT")))]
                        )
                      : _vm._e()
                  ])
                : _c("div", { staticClass: "btn_right" }, [
                    _vm.KNOWLEDGE_ID.length && _vm.STATUS === "P"
                      ? _c(
                          "a",
                          {
                            staticClass: "btn_white",
                            attrs: { href: "javascript:" },
                            on: { click: _vm.btnDelete }
                          },
                          [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.DELETE")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.KNOWLEDGE_ID.length &&
                    _vm.STATUS === "C" &&
                    _vm.IfFirstApproval
                      ? _c(
                          "a",
                          {
                            staticClass: "btn_white",
                            attrs: { href: "javascript:" },
                            on: { click: _vm.btnDelete }
                          },
                          [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.DELETE")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.processStep === 1 && _vm.getIsModify
                      ? _c(
                          "a",
                          {
                            staticClass: "btn_white",
                            attrs: { href: "javascript:" },
                            on: { click: _vm.btnPreview }
                          },
                          [_vm._v(_vm._s(_vm.$t("BUTTON.NOTICE.PREVIEW")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    (_vm.STATUS === "" || _vm.STATUS === "P") &&
                    _vm.processStep < 4
                      ? _c(
                          "a",
                          {
                            staticClass: "btn_white",
                            attrs: { href: "javascript:" },
                            on: { click: _vm.btnSaveDraft }
                          },
                          [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.SAVEDRAFT")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.processStep > 3 && _vm.getIsModify
                      ? _c(
                          "a",
                          {
                            staticClass: "btn_blue",
                            attrs: { href: "javascript:" },
                            on: { click: _vm.btnRegister }
                          },
                          [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.REGISTER")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    (_vm.STATUS === "S" || _vm.STATUS === "C") &&
                    !_vm.getIsModify
                      ? _c(
                          "a",
                          {
                            staticClass: "btn_white",
                            attrs: { href: "javascript:" },
                            on: { click: _vm.btnModify }
                          },
                          [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.EDIT")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.STATUS === "S" && !_vm.getIsModify
                      ? _c(
                          "a",
                          {
                            staticClass: "btn_white",
                            attrs: { href: "javascript:" },
                            on: { click: _vm.btnExpire }
                          },
                          [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.EXPIRE")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.processStep < 4
                      ? _c(
                          "a",
                          {
                            staticClass: "btn_blue",
                            attrs: { href: "javascript:" },
                            on: { click: _vm.btnNext }
                          },
                          [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.NEXT")))]
                        )
                      : _vm._e()
                  ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "154" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "154" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "154" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "15%" } }),
      _vm._v(" "),
      _c("col", { staticClass: "pc_only", attrs: { width: "15%" } }),
      _vm._v(" "),
      _c("col", { staticClass: "pc_only", attrs: { width: "25%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d6ded0e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d6ded0e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/knowledge/popup/KnowledgeContentsPopup.vue
// module id = mZ/P
// module chunks = 0